export default __webpack_public_path__ + "static/media/chrome.b0bd08e3.svg";